export default "__VITE_ASSET__BvCNQYlG__"